import React from 'react';
import {GlossaryLogo as GlossaryLogoImage} from '../../Icons';
import {Image} from '@learningblocks/shared-components/lib/Image';
import style from './style.module.scss';

export function GlossaryLogo() {
  return (
    <div className={style.glossaryLogo}>
      <Image src={GlossaryLogoImage} alt='Glossary Logo' />
      <h3>Glossary</h3>
    </div>
  );
}

GlossaryLogo.propTypes = {};

GlossaryLogo.defaultProps = {};
